
import { getCookie } from 'cookies-next';

const baseUrl = process.env.NEXT_PUBLIC_BASE_URL

export const getFilteredNewDevelopments = async (filters, email = null) => {
    let currencyValue = getCookie('currency')
    let localeValue = getCookie('NEXT_LOCALE')
    // console.log(currencyValue)

    const { saleType, bts, project, category, room, minBedrooms, maxBedrooms, page, currency, minprice, maxprice, petfriendly, seaview, beachfront, map, sort, limit = 5, district, location } = filters
    // console.log(filters)
    const url = `${baseUrl}/projects/newdevelopments?page=${page}&category=${category}&sort=${sort}&limit=${limit}`
    const headers = {
        'apikey': process.env.NEXT_PUBLIC_RSTBASE_API_KEY,
        'email': email,
        'currency': currencyValue || 'thb',
        'locale': localeValue || 'en'
    }

    const response = await fetch(url, {
        headers: headers,
        cache: 'no-store'
    })

    const result = await response.json()
    // console.log(result)


    // console.log(result)
    
    return result

}